
export function init() {
  $(window).on('load', function () {
    const showModal = sessionStorage.getItem("showModal");

    if (showModal !== "false") {
      $('#modal-discount').modal('show');
      sessionStorage.setItem("showModal", false);
    }
  });
}
